import axios from "../../axios";

const deleteProxy = async function (accessToken, id) {
    try {
        const response = await axios.post('proxy/deleteProxy', { id }, {
            headers: {
                'Authorization': accessToken,
                'Content-Type': 'application/json'
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response?.status || 500,
            message: e.response?.data?.message || 'Có lỗi xảy ra'
        }
    }
}

export default deleteProxy;

